import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { changePassword } from '../../../lib/api';
import '../../admin/pages/admin.css';

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError('Please fill in all fields.');
      return;
    }

    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New password and confirmation do not match.');
      return;
    }

    if (oldPassword === newPassword) {
      setError('New password must be different from your current password.');
      return;
    }

    setSubmitting(true);
    try {
      const res = await changePassword({ oldPassword, newPassword });
      setMessage(res?.message || 'Password changed successfully.');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err?.message || 'Failed to change password.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-page">
      <header className="admin-page__hero">
        <div className="admin-page__title-row">
          <div className="admin-page__icon" aria-hidden>
            <FontAwesomeIcon icon={faLock} />
          </div>
          <div>
            <span className="admin-page__eyebrow">Account</span>
            <h1 className="admin-page__title">Change password</h1>
            <p className="admin-page__subtitle">
              Enter your current password, then choose a new one. You will stay signed in after updating.
            </p>
          </div>
        </div>
      </header>

      <section className="admin-panel">
        <div className="admin-panel__head">
          <h2>Update password</h2>
          <p>Use a strong password with at least 6 characters.</p>
        </div>
        <div className="admin-panel__body">
          <form onSubmit={onSubmit}>
            <div className="admin-grid">
              <div className="admin-field">
                <label className="admin-label" htmlFor="old-password">
                  Current password
                </label>
                <input
                  id="old-password"
                  type="password"
                  className="admin-input"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  autoComplete="current-password"
                  disabled={submitting}
                />
              </div>
              <div className="admin-field">
                <label className="admin-label" htmlFor="new-password">
                  New password
                </label>
                <input
                  id="new-password"
                  type="password"
                  className="admin-input"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  autoComplete="new-password"
                  disabled={submitting}
                />
              </div>
              <div className="admin-field">
                <label className="admin-label" htmlFor="confirm-password">
                  Confirm new password
                </label>
                <input
                  id="confirm-password"
                  type="password"
                  className="admin-input"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                  disabled={submitting}
                />
              </div>
            </div>

            {error && (
              <div className="admin-feedback admin-feedback--error" style={{ marginTop: 16 }} role="alert">
                {error}
              </div>
            )}
            {message && (
              <div className="admin-feedback admin-feedback--success" style={{ marginTop: 16 }} role="status">
                {message}
              </div>
            )}

            <div className="admin-actions" style={{ marginTop: 20 }}>
              <button type="submit" className="admin-btn admin-btn--primary" disabled={submitting}>
                {submitting ? 'Updating…' : 'Change password'}
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default ChangePassword;
